import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { BillingFacade } from '@app/shared/+state/billing';
import { UpsellService } from '@app/shared/+state/shared/upsell.service';
import { StorylaneService } from '@app/shared/services/storylane.service';

@Component({
  standalone: false,
  selector: 'sbnb-demo-statements',
  templateUrl: './demo-statements.component.html',
  styleUrls: ['./demo-statements.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemoStatementsComponent implements OnInit {
  public isTrial$ = this.billingFacade.isTrialSubscription$;

  constructor(
    private billingFacade: BillingFacade,
    private storylaneService: StorylaneService,
    private upsellService: UpsellService
  ) {}

  ngOnInit(): void {
    this.billingFacade.loadSubscription();
  }

  public takeTour() {
    this.storylaneService.tourOwnerStatements();
  }

  public contactSales() {
    this.upsellService.contactSalesForMogul('StatementsDemoPage');
  }

  public redirectToPlans() {
    this.upsellService.redirectToPlans();
  }
}
